/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular.module('prism-ui.categories').service('CategoriesService',
    function (this: JS5Object, CategoriesResourceFactory: JS5Object) {
        this.originalEditData = {};
        this.viewData;


        this.getAllCategories = (criteria: JS5Object) => {
            return CategoriesResourceFactory.getAllCategories(criteria).$promise;
        };
        this.getCategoryTypes = () => {
            return CategoriesResourceFactory.getCategoryTypes().$promise;
        };
        this.createCategory = (category: JS5Object) => {
            return CategoriesResourceFactory.createCategory(category).$promise;
        };
        this.getCategory = (categoryId: number) => {
            return CategoriesResourceFactory.getCategory({id: categoryId}).$promise
        };
        this.updateCategory = (category: JS5Object) => {
            return CategoriesResourceFactory.updateCategory(category).$promise;
        };
        this.deleteCategory = (categoryId: number) => {
            return CategoriesResourceFactory.deleteCategory({id: categoryId}).$promise
        };
    });
